import React from "react";
import { useParams } from "react-router-dom";

import projectsData from "../data/projects.json";
import MainSlider from "../components/MainSlider";
import Banner from "../components/Banner";
import LocationDistances from "../components/LocationDistances";
import PortfolioGallery from "../components/PortfolioGallery";
import ProjectVideo from "../components/ProjectVideo";

const images = import.meta.glob('../assets/img/**/*.{jpg,png,jpeg}', {
    eager: true,
    query: '?url',
    import: 'default',
});

function getImageUrl(relPath) {
    return images[`../assets/img/${relPath}`];
}

export default function ProjectPage() {
    const { slug } = useParams();
    const project = projectsData[slug];

    if (!project) return <div>Proje bulunamadı</div>;

    document.title = `HCP Yapı - ${project.name}`;

    const mainSlider = project.mainSlider.map(s => ({
        ...s,
        image: getImageUrl(s.image)
    }));

    const galleryData = project.gallery.map(g => ({
        ...g,
        image: getImageUrl(g.image),
    }));

    const badges = project.badges.map(badge => ({
        content: (
            <>
                {badge.content.map((el, i) => (
                    <div key={i} style={{ fontWeight: el.fontWeight, fontSize: el.fontSize }}>{el.text}</div>
                ))}
            </>
        ),
    }));

    return (
        <>
            <MainSlider slidesData={mainSlider} badges={badges} />
            <Banner {...project.banner} logoSrc={getImageUrl(project.logo)} />
            <LocationDistances locationSrc={project.location.src} points={project.points} highlightBlockProps={{ bgLabel: project.name, calligraphy: "Proje Hakkında" }} />
            {project.video && (
                <ProjectVideo src={project.video} title={project.name + " Video"} highlightBlockProps={{ bgLabel: project.name, calligraphy: "Tanıtım Videosu" }} />
            )}
            <PortfolioGallery slides={galleryData} highlightBlockProps={{ bgLabel: project.name, calligraphy: 'Galeri' }} />
        </>
    );
}
